import M from 'backbone.marionette'
import T from './edit.html'
import Backbone from 'backbone';
import { FormElement } from '../../utils/bootstrap/formelement';
import { FormHandler } from '../../utils/bootstrap/form/formhandler';
import { Toast } from '../../utils/bootstrap/toast';
import { PunchListitem } from './punchListItem';
import Radio from 'backbone.radio';
import moment from 'moment';
import { minutesToTimeString, timeStringToMinutes } from '../../utils/utils';


export const EditPunch = M.View.extend({
    template: _.template(T),
    punches: null,
    user: null,
    enseignant: null,
    initialize: function(){
        // délier le modèle, si annulation on veut pas affecter le modèle initial
        this.model = this.model.clone();
        this.model.set('punchTimeString', minutesToTimeString(this.model.get('punchTimeInMinutes')))
        this.user = this.getOption('mainModel').get('user');
        
    },
    serializeData: function(){
        return _.extend(this.model.toJSON(), {
            user: this.user.toJSON(),
        })
    },
    ui: {
        btSubmit: '.btSubmit', 
        btAnnuler: '.btAnnuler',
        enseigantFormGroup: '.enseigantFormGroup'
    },
    regions: {
        'punchType': {
            el: '#punchType',
            replaceElement: true,
        },
        'punchDate': {
            el: '#punchDate',
            replaceElement: true,
        },
        'punchTimeInMinutes': {
            el: '#punchTimeInMinutes',
            replaceElement: true,
        },
        'punchTimeInMinutes': {
            el: '#punchTimeInMinutes',
            replaceElement: true,
        },
        'teacherComments':{
            el: '#teacherComments',
            replaceElement: true,
        }
    },
    events: {
        'click #plus15': 'onPlus15',
        'click #plush': 'onPlusH',
        'click .btSubmit': 'onSubmit',
        'click .btAnnuler': 'onCancel',
        'click .btnBtValidate':'onValidate',
        'click .btnBtInvalidate':'onInvalidate',
    },
    onRender: function(){

        this.showChildView('punchType', new FormElement({
            horizontal: false,
            type: 'select',
            model: this.model,
            attribute: 'punchType',
            collection: this.getOption('mainModel').get('punchTypes')
        }));

        this.showChildView('punchDate', new FormElement({
            horizontal: false,
            type: 'date',
            model: this.model,
            attribute: 'punchDate',
        }));
        this.showChildView('punchTimeInMinutes', new FormElement({
            horizontal: false,
            type: 'time',
            model: this.model,
            attribute: 'punchTimeString',
        }));
        
        if(this.user.get('Type') === 'enseignant' && this.user.get('id') == this.model.get('enseignant_id')){
            this.showChildView('teacherComments', new FormElement({
                horizontal: false,
                type: 'textarea',
                model: this.model,
                attribute: 'teacherComments',
            }));
        }

        
    },
    onPlus15: function(){
        // get current time value
        var timeStr = this.model.get('punchTimeString');
        if(!timeStr)timeStr = '00:00';
        var parts = timeStr.split(':');
        var date = new Date();
        date.setHours(parseInt(parts[0]));
        date.setMinutes(parseInt(parts[1]));
        // add 15 minutes
        date.setMinutes(date.getMinutes() + 15);
        // set back
        var h = date.getHours();
        if(h<10)h='0'+h;
        var m = date.getMinutes();
        if(m<10)m='0'+m;
        this.model.set('punchTimeString', h+':'+m);    
    },
    onPlusH: function(){
        // get current time value
        var timeStr = this.model.get('punchTimeString');
        if(!timeStr)timeStr = '00:00';
        var parts = timeStr.split(':');
        var date = new Date();
        date.setHours(parseInt(parts[0]));
        date.setMinutes(parseInt(parts[1]));
        // add 1 hour
        date.setHours(date.getHours() + 1);
        // set back
        var h = date.getHours();
        if(h<10)h='0'+h;
        var m = date.getMinutes();
        if(m<10)m='0'+m;
        this.model.set('punchTimeString', h+':'+m);
    },
    onSubmit: function(){
        const formHandler = new FormHandler();
        const clone = this.model.clone()
        clone.set('punchTimeInMinutes', timeStringToMinutes(clone.get('punchTimeString')));
        formHandler.addModel('punch', clone);

        this.ui.btAnnuler.prop('disabled', true);
        this.ui.btSubmit.prop('disabled', true);
        formHandler.save('api/specialiste/sauvegarderpunch/',
            this.onPuchSaved.bind(this),
            this.onPunchAdderror.bind(this)
        )
    },
    onPuchSaved: function(response){
        this.model.set(response);
        this.ui.btAnnuler.prop('disabled', false);
        this.ui.btSubmit.prop('disabled', false);
        Radio.channel('punch').trigger('save', response);
        this.triggerMethod('close', this);
    },
    onPunchAdderror:function(errors){
        Toast.add('Une erreur a eu lieu :(', 'danger')
        this.ui.btAnnuler.prop('disabled', false);
        this.ui.btSubmit.prop('disabled', false);
        if (errors) {
            showAlert('Erreur', errors.join('<br />'));
        }
    },
    onCancel: function(){
        this.triggerMethod('close', this);
    },
    onValidate: function(){
        this.model.set({
            'validateContributeur_id':this.user.get('id'),
            'validateDate': moment().format('YYYY-MM-DD')
        });
        this.render();
    },
    onInvalidate: function(){
        console.log('invalidate')
        this.model.set({
            'validateContributeur_id': null,
            'validateDate': null
        });
        this.render();
    }

})
